import { useState } from 'react';
import { Link } from 'react-router-dom';
import type { DomainAlert } from '@/hooks/useDomainMonitor';

interface Props {
  alert: DomainAlert | null;
  to?: string;
  label?: string;
}

/**
 * Bandeau d'alerte « domaine » — affiché quand la vérification périodique
 * détecte un domaine expiré / en erreur (SSL, DNS, désactivé).
 */
export default function DomainAlertBanner({ alert, to, label = 'Vérifier' }: Props) {
  const [dismissed, setDismissed] = useState(false);
  if (!alert || dismissed) return null;

  const tone =
    alert.tone === 'danger'
      ? 'bg-red-50 border-red-200 text-red-700'
      : 'bg-accent-50 border-accent-200/70 text-accent-800';
  const icon = alert.tone === 'danger' ? 'ri-shield-flash-line' : 'ri-time-line';

  return (
    <div className={`flex items-center gap-3 px-4 py-3 rounded-lg border ${tone}`}>
      <i className={`${icon} text-base flex-shrink-0`}></i>
      <span className="flex-1 min-w-0 text-sm">{alert.message}</span>
      {to && (
        <Link
          to={to}
          className="text-xs font-semibold whitespace-nowrap underline-offset-2 hover:underline cursor-pointer"
        >
          {label}
        </Link>
      )}
      <button
        onClick={() => setDismissed(true)}
        className="w-6 h-6 flex items-center justify-center rounded-md hover:bg-black/5 transition-colors cursor-pointer flex-shrink-0"
        title="Masquer"
      >
        <i className="ri-close-line text-sm"></i>
      </button>
    </div>
  );
}